/**
 * Hero with Image Template
 *
 * A Framer-inspired hero section with centered headline, subheading, and large image below.
 */

const heroWithImage = {
  id: 'hero-with-image',
  name: 'Hero with Image',
  category: 'hero',
  description: 'Centered headline with large image below',
  thumbnail: null,
  content: {
    section_type: 'layout-1',
    sectionBackgroundColor: '#ffffff',
    backgroundImage: '',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    marginTop: '0',
    marginBottom: '0',
    paddingTop: '80',
    paddingBottom: '64',
    paddingLeft: '24',
    paddingRight: '24',
    components: [
      {
        id: 'hero-with-image-row-1',
        type: 'row',
        props: {
          direction: { base: 'horizontal', tablet: null, desktop: null },
          gap: 'md',
          alignment: 'stretch',
          justifyContent: 'center',
          flexWrap: 'wrap',
          columnLayout: { base: 'equal', tablet: null, desktop: null },
          columnWidths: [],
          width: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
          maxWidth: { base: { value: '1000', unit: 'px' }, tablet: null, desktop: null },
          padding: { base: { top: 0, bottom: 0, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
          margin: { base: { top: 0, bottom: 0, left: 'auto', right: 'auto', unit: 'px' }, tablet: null, desktop: null },
          backgroundColor: 'transparent',
          backgroundImageUrl: '',
          borderWidth: 0,
          borderStyle: 'solid',
          borderColor: 'transparent',
          borderRadius: 0,
          overflow: 'visible',
          visibility: { base: true, tablet: null, desktop: null },
          position: 'relative',
          top: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
          right: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
          bottom: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
          left: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
          zIndex: 'auto',
          customCSS: '',
        },
        children: [
          {
            id: 'hero-with-image-col-1',
            type: 'column',
            props: {
              gap: 'lg',
              alignItems: 'center',
              justifyContent: 'center',
              span: { base: 12, tablet: null, desktop: null },
              width: { base: { value: '100%', unit: '%' }, tablet: null, desktop: null },
              padding: { base: { top: 0, bottom: 0, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
              margin: { base: { top: 0, bottom: 0, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
              backgroundColor: 'transparent',
              borderWidth: 0,
              borderStyle: 'solid',
              borderColor: 'transparent',
              borderRadius: 0,
              overflow: 'visible',
              visibility: { base: true, tablet: null, desktop: null },
              position: 'relative',
              top: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
              right: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
              bottom: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
              left: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
              zIndex: 'auto',
              customCSS: '',
            },
            children: [
              {
                id: 'hero-with-image-heading',
                type: 'text',
                props: {
                  content: 'Meet Framer',
                  element: 'h1',
                  fontFamily: 'System Default',
                  fontSize: 48,
                  fontWeight: 'bold',
                  lineHeight: 1.2,
                  letterSpacing: 0,
                  color: '#1a1a1a',
                  textAlign: 'center',
                  textTransform: 'none',
                  padding: { base: { top: 0, bottom: 0, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
                  margin: { base: { top: 0, bottom: 16, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
                  borderWidth: 0,
                  borderStyle: 'solid',
                  borderColor: 'transparent',
                  borderRadius: 0,
                  visibility: { base: true, tablet: null, desktop: null },
                  position: 'static',
                  top: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                  right: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                  bottom: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                  left: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                  zIndex: 'auto',
                  customCSS: '',
                },
                children: [],
              },
              {
                id: 'hero-with-image-subheading',
                type: 'text',
                props: {
                  content: 'Internet canvas.',
                  element: 'p',
                  fontFamily: 'System Default',
                  fontSize: 24,
                  fontWeight: 'normal',
                  lineHeight: 1.5,
                  letterSpacing: 0,
                  color: '#999999',
                  textAlign: 'center',
                  textTransform: 'none',
                  padding: { base: { top: 0, bottom: 0, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
                  margin: { base: { top: 0, bottom: 32, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
                  borderWidth: 0,
                  borderStyle: 'solid',
                  borderColor: 'transparent',
                  borderRadius: 0,
                  visibility: { base: true, tablet: null, desktop: null },
                  position: 'static',
                  top: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                  right: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                  bottom: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                  left: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                  zIndex: 'auto',
                  customCSS: '',
                },
                children: [],
              },
              {
                id: 'hero-with-image-image',
                type: 'image',
                props: {
                  src: 'https://via.placeholder.com/1000x500/f5f5f5/cccccc?text=Your+Image+Here',
                  alt: 'Hero image placeholder',
                  linkUrl: '',
                  openInNewTab: false,
                  width: { base: { value: 100, unit: '%' }, tablet: null, desktop: null },
                  height: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                  maxWidth: { base: { value: 900, unit: 'px' }, tablet: null, desktop: null },
                  objectFit: 'cover',
                  objectPosition: 'center',
                  aspectRatio: 'auto',
                  padding: { base: { top: 0, bottom: 0, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
                  margin: { base: { top: 0, bottom: 0, left: 'auto', right: 'auto', unit: 'px' }, tablet: null, desktop: null },
                  borderWidth: 0,
                  borderStyle: 'solid',
                  borderColor: 'transparent',
                  borderRadius: 16,
                  opacity: 100,
                  filter: 'none',
                  visibility: { base: true, tablet: null, desktop: null },
                  position: 'static',
                  top: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                  right: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                  bottom: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                  left: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                  zIndex: 'auto',
                  customCSS: '',
                },
                children: [],
              },
            ],
          },
        ],
      },
    ],
  },
};

export default heroWithImage;
